module.exports = __webpack_public_path__ + "static/media/card_dealt.6ecd8865.wav";